module.exports = __webpack_public_path__ + "img/otherWay.f4c3d940.png";